import { Button, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import CustomProductIntTextField from "../../unit/forms/CustomProductIntTextField";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import CustomProductActionBottom from "../CustomProductActionBottom";
import { NoContentSet } from "./NoContentSet";

export default function PurchaseInfo({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "purchaseinfo";
  const sectionTitle = "Purchase Info";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.purchaseinfo?.purchaseConfigData;
  const dMaxPurchaseProducts =
    record?.data?.basic?.purchaseinfo?.dMaxPurchaseProducts;
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        dMaxPurchaseProducts: dMaxPurchaseProducts || "N/A",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
        }}
      >
        {productModulesGroup?.includes("purchaseinfo") && (
          <>
            {Object.entries(data).map(([key, item]) => (
              <>
                <Grid
                  container
                  sx={{ backgroundColor: "#f5f5f5", padding: "10px" }}
                >
                  <Grid item xs={4}>
                    <FieldTitle title={item?.title} />
                  </Grid>
                  <Grid item xs={4}>
                    {key == "Product" && (
                      <>
                        <Controller
                          name="dMaxPurchaseProducts"
                          control={control}
                          defaultValue={data?.dMaxPurchaseProducts}
                          // render select ,dMaxPurchaseProducts, 1,2,3,4,5,6 N/A
                          render={({ field }) => (
                            <CustomProductSelect
                              {...field}
                              label="Maximum Number of Items"
                              sx={{ width: "200px" }}
                              optionlist={[
                                { value: "", label: "N/A" },
                                { value: "1", label: "1" },
                                { value: "2", label: "2" },
                                { value: "3", label: "3" },
                                { value: "4", label: "4" },
                                { value: "5", label: "5" },
                                { value: "6", label: "6" },
                              ]}
                            />
                          )}
                        />
                      </>
                    )}
                  </Grid>
                  <Grid item xs={2} sx={{ pl: 2 }}>
                    <FieldTitle title={"Application"} />
                  </Grid>
                  <Grid item xs={2} sx={{ pl: 2 }}>
                    <FieldTitle title={"Final Approval"} />
                  </Grid>
                </Grid>
                <Box sx={{ padding: "10px" }}>
                  {item?.list &&
                    Object.entries(item?.list).map(([key, itemval]) => (
                      <Grid container spacing={2}>
                        <Grid item xs={4} sx={{ pl: 3 }}>
                          {itemval?.sCaption}
                        </Grid>
                        <Grid item xs={4}>
                          {/* @if($itemkey == 'specific_documents')
                                  <input type="text" name="purchaseitemIds_itemvalue_{{$itemkey}}" placeholder="Enter Document Name" style="width:250px;" >
                          @endif
                
                          @if($itemkey == 'min_payment')
                                <input type="text" name="purchaseitemIds_itemvalue_{{$itemkey}}" placeholder="" @if($itemsDefaultValue) value="{{$itemsDefaultValue}}" @endif style="width:100px;" >%
                          @endif */}
                          {itemval?.sField == "specific_documents" && (
                            <Controller
                              name={`purchaseitemIds_itemvalue_${itemval?.sField}`}
                              control={control}
                              defaultValue={itemval?.itemsDefaultValue}
                              render={({ field }) => (
                                <CustomProductTextField
                                  {...field}
                                  placeholder="Enter Document Name"
                                />
                              )}
                            />
                          )}
                          {itemval?.sField == "min_payment" && (
                            <Controller
                              name={`purchaseitemIds_itemvalue_${itemval?.sField}`}
                              control={control}
                              defaultValue={itemval?.itemsDefaultValue}
                              render={({ field }) => (
                                <CustomProductIntTextField {...field} small />
                              )}
                            />
                          )}
                        </Grid>
                        <Grid item xs={2}>
                          <Controller
                            name={`purchaseitemIds_app_required_${itemval?.sField}`}
                            control={control}
                            defaultValue={itemval?.itemAppRequired}
                            render={({ field }) => (
                              <CustomProductSelect
                                {...field}
                                small
                                optionlist={[
                                  { value: "N/A", label: "N/A" },
                                  { value: "Optional", label: "Optional" },
                                  { value: "Required", label: "Required" },
                                ]}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          {/* purchaseitemIds_required_{sField}, N/A, Optional, Required  */}
                          <Controller
                            name={`purchaseitemIds_required_${itemval?.sField}`}
                            control={control}
                            defaultValue={itemval?.itemRequired}
                            render={({ field }) => (
                              <CustomProductSelect
                                {...field}
                                small
                                optionlist={[
                                  { value: "N/A", label: "N/A" },
                                  { value: "Optional", label: "Optional" },
                                  { value: "Required", label: "Required" },
                                ]}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    ))}
                </Box>
              </>
            ))}
          </>
        )}
        {!productModulesGroup?.includes("purchaseinfo") && <NoContentSet />}
      </Box>
      {productModulesGroup?.includes("purchaseinfo") && (
        <>
          {/* Form Actions */}
          <CustomProductActionBottom>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveClick}
              disabled={!isDirty}
              sx={{ width: "120px", mt: 1 }}
            >
              Save
            </Button>
          </CustomProductActionBottom>
        </>
      )}
    </SectionStyled>
  );
}
